import { ProfileRecommendation } from 'containers/recommendations/types/recommendations'
import { User } from 'containers/user/types/user'
import { ProfileCardBase } from './ProfileCardBase'
import { cssClass } from '@/shared/utils'
import { recommendationCardButtons } from 'containers/profile-network/styles/connectionCard.css'
import { RequestConnectionButton } from 'containers/profile/components/buttons/RequestConnectionButton'

interface ConnectionRequestCardProps {
  profile: User | ProfileRecommendation
  onDismiss?: (id: string) => void
  isInRecommendationsColumn?: boolean
}

export const RecommendationCard = ({
  profile,
  onDismiss,
  isInRecommendationsColumn = false,
}: ConnectionRequestCardProps) => {
  const deleteNewConnection = async () => {
    onDismiss && onDismiss(profile?.id)
  }

  return (
    <ProfileCardBase
      profile={profile}
      useSmallCard
      isInRecommendationsColumn={isInRecommendationsColumn}
    >
      <div className={cssClass([recommendationCardButtons, 'ml-auto mr-0'])}>
        <RequestConnectionButton
          profile={profile}
          useDismiss
          onDismiss={deleteNewConnection}
          maxWidthClass="full-w"
          containerClassName="full-w"
          buttonClassName="full-w"
        />
      </div>
    </ProfileCardBase>
  )
}
